import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex);
let store = new Vuex.Store({
	state: {
		stateObject: {
			themeCss: {
				color: "#FF8F00"
			},
			parmStr: "",
			parmPass: null,
			pageMap: {},
			userInfo: {},
			projectData: {},//项目详情
			isEditProjectInfoSuccess: false,//是否编辑项目信息成功
			isAdjustPersonnel: false,//是否分配任务
			customerInfo: "",//业主详情
			signCustomer: {},//签约业主
			isUpdateCustomerSuccess: false,//是否编辑业主信息成功
			selectedGiftItem: null,//选择礼物
			tempSelectedGiftItem: null,//选择礼物(签约返回)
			selectedGiftType: 0,
			customerId: "",//业主ID
			isAddServiceSuccess: false,//是否添加服务费成功
			isRefundSuccess: false,//是否退款成功
			yxparkInfo: null,//意向车位
			finalDetail: {},//尾款对象
			isSavePaymentSuccess: false,//是否保存尾款成功
			isSaveSignSuccess: false,//是否保存签约成功
			isAddEntranceSuccess: false,//是否添加场次成功
			isReportedSuccess: false,//是否报备成功
			isProcessSuccess: false,//是否选择项目流程
			processProject: "",//项目流程选择项目
			managerProject: "",//团队管理选择项目
			backRefreshPage: false,//回退是否刷新上级页面
			isAddFollowSuccess: false,//是否添加项目跟进成功
			isSelectedYxparkInfo: false,//是否选择意向车位
			parkingSpaceNumServiceFee: null,//车位服务费
			isRefreshCheckList: false,//是否选择意向车位
			bankList: [],//选中的银行卡
			statisticsDetailProject: "",//统计选择项目
			tagListJson: "",//标签列表
			refundData: null,//退还礼品列表
			msgDetail: "",//消息详情
			msgToailCount: 0,//消息总数量
			backRefreshMsgPage: false,//刷新消息界面
			feedBackIsRead: false,//是否有未读意见反馈消息
			repairServiceJson: "",//补缴服务费JSON
			baiduToken: "",//百度账号登录Token
			subsequentSigningInfo: {},//签约后续
			newUploadFile: null,//新增附件内容
			processChildData: null,//流程二级页面交互数据
			processChildComonData: null,//流程二级页面交互数据模板
			customSearchData: "",//业主查询数据
			projectGiftPlant: null,//礼品/费用预算
			staffInfo: [],//员工信息
			passProject: null,//流程撤场转移人员
			dataFeeInfo: [],//资料费
			cashTransmitData: [],//现金收款传参
			itemConfirmationData: [],//物品确认
			saveInventoryData: null,//库存盘点溢出缺失数据
			haveARestStaffId: [],//调休人员
			objectData: null,//目标数据
			backRefreshObject: false,//刷新目标数据
			mallCurrencySetting: [],//商城积分设置后存值
			toMallCurrencySettingPara: [],//到商城积分设置需传值
			preferentialConditionsPara: null,//优惠情况详情值
			stallFoorInfo: null,//车位楼层信息
			OAProjectInfo: null,//报销选择项目
			OACollectionAccountInfo: null,//收款账户传值
			OACollectionAccountSelect: null,//收款账户选中值
			CCStaffData: null,//oa选择抄送人传值
			pressForMoneyProject: "",//催收选择项目
			pressForMoneyData: "",//催收信息
			labelFilteringParam: [],//标签筛选
			borrowingData: {},//借用记录单条信息
			purchaseGoodsPara: [],//采购选择商品传值
			goodsFeedBackSelectItem: null,//商品反馈选择
			preferentialSetByval: null,//优惠设置传值
			reportRemark: "",//问卷调查报告
			backRefreshPage2: false,//回退是否刷新上级页面(垮二级)
			speechcraftDetail:null,//话术详情
			receiptProject:"",//借用项目信息
			contentData:null,//通用title，content数据展示
			isNoticeIndex:null,//催收消息状态索引
			mortgageDocumentData:[],//抵押文件传值
			outTimeAlertDataList:null,//待撤场项目
			proprietorInfoEditRecord:null,//业主信息修改记录
			staffIntegral:0,//员工积分
			medalNum:0,//勋章数量
			staffViolationNumber:0,//违纪次数
			serviceAgreementApplyList:null,//服务协议选中
			serviceAgreementApplyData:null,//服务协议分批数据
			PKRefundProjectInfo:null,//pk退款选择pk信息
			colletProject: null,
			isRefresh: false,
			refundPersonId:null,//pk退款申请选中人员
			getTokening:false,//正在刷新token
			alertOut:false,//正在弹框退出
			tokenRefreshTime:new Date(),//记录第一次登录时间
			selectSpaceTime:["time1","time2","time3"],//time1:disable截止时间，time2：开始时间，time3：结束时间
			supportProjectInfo:null,//选择资源项目信息
			withdrawalPageInfo:null,//撤场审核详情
			giftsAfterSign:null,//签约后送礼列表带到详情
			referrerCheckData:null,//推荐人审核
			remainProblemsData:null,//遗留问题
			lecturerDetail:null,//讲师详情
			totalBottom:false,//统计滚动底部
			clockInData:null,//打卡地图标记数据
			passWeekData:null,//每日一通数据
			BusinessCollegeCount:0,//商学院代办
			weeklyOncePassCount: 0,//每周一通待办
			dailyOncePracticeCount:0,//每日一练待办
			weeklyOncePracticeCount:0,//每周一练待办
			totalCount:0,//商学院各模块待办总数
			carBrandData:null,//车辆品牌选择
			supportPerson:null,//支援项目选择人员
			callRecordProjectItem:null,//录音分享选择项目场次
			selectSelfPrjectInfoData:null,//选择自己项目
			showNotCompletObject:[],//弹框提示未完成目标项目场次为维度
			saleStaffInfo: [],//指定调动人员姓名
			selectIndex: null, //点击的索引
			personMoveStaffList:null,//人员调动选择销售人员
			refreshStampedePlatedNum:false,//刷新分配人员踩盘数
			reimbursement:null,//选择返回商户
			merchantTypeFee:null,//选择人工及材料费
			merchantTypeParkList:null,//选择车位
			anonymousDetail:{},//匿名信详情
			selectProjectInventory:null,//选择项目库存
			newPower: null,//新能源相关
			selectPOSInfo:null,//选择POS机
			isSendCharging:false,//是否赠送充电桩
			processChildComonPageData: null,//流程通用二级页面交互数据模板
			processChildDataCL:null,//策略
			projectProcessPersonPassData:null,//人员明细信息
			scanComonData:null,//项目流程通用查看浏览
			processCheckJSONStr:null,
			selectAdvertisementData:null,//项目流程选择广告
			processChildDataContent:null,//单纯内容
			customerMaintenanceRecommend:null,//客情推荐费
			customerMaintenanceRecommendSelect:null,//客情推荐费标准选择
			customerMaintenanceRecommendOldSelect:null,//客情推荐费标准已选择
			reserveTransitSelect:null,//中转仓选中
			reserveTransitSelected:null,//中转已选中
			reserveTransitDetail:null,//中转详情
			customerServiceFee: [], //客情推荐费详情
			secondCustomerServiceFee: {}, //二级页面客户推荐费详情
			reserveInventoryDetailHisTemp:null,//库存盘点临时存放转移
			projectName: "",
			watPassTeam:null,//团队人员分配传值人员列表
			backFuncWatPassTeam:false,//团队人员分配回调方法
			scrapParkingList: [],
			cancelScrapParking: [],
			developPassData:null,//拓展PK详情
			projectNameAndHisTime: [],
			processDataPassForSale:null,//销售流程传值
			scoreInfo: null,
			weekPlantDetailOtherPlanStateId:"",//周计划额外任务标记更新
			selectedAdvertisingTemps: [], //选定的广告模板数据
			hasSelectedAdvertisingDetails: [], //已选的广告明细
			integralReportingData: null,//综合积分提报数据
			activeIndexFlag: null,
			lklOrderInfo:null,//pos机订单详情
			refundCustomerPosDetailList:null,//退款POS编号
			bestContributionStaffObj: null,//最佳贡献奖候选人信息
			selectCustomer:null,//选择业主信息
			selectCompanyPerson:null,//选择公司人员
			reportData:null,//问卷调查
			commonComment:null,//通用评价
			selectRefundInfo:null,//付款退款
			meetingObj: null,//会议详情
			referenceSelectData:null,//选择推荐人
			referenceSelectSettlementData:null,//推荐费结算
            interviewDetailItem: null, //面试详情
			firstResultObj: "",
			parkNumData: null,
			callUrlArry: null,
			grantGiftSelectData:null,//送礼核销选礼品
			fromView: false,
			waitWithdrawAuditArr: null,//撤场待审核的id列表
			callCenterItemIndex: -1,
			callQueryIds: null,//呼叫明细queryId列表
			waitCheckList: null,//优惠待审核列表
			depositWechartDetail:null,//微信支付订单信息
			selectPersonsForBorrowing:null,//物品借用选择人员
			distributionData: null,//分销详情数据
			thanksImage: null,//感谢函参数
			liveRoomData:null,//直播间数据
			selectedGiftItemOther: null,//其他已选礼物
			selectActionWX:null,//选择微信活动
			projectTeamInfoAndManager:null,//选择团队人员
			customerVisitPassData:null,//带看数据传值
			selectRoomNoForVote: null,//投票活动选择房号
			projectAllInfo:null,//项目全部信息
		}

	},
	mutations: {
		stateFn(state, source) {
			let stateObject = state.stateObject;
			for (let i in source) {
				let key = stateObject[i];
				if (key) {
					let newObj = deepClone({}, state.stateObject[i], source[i]); //这样深拷贝没有getter,setter属性
					let o = {};
					o[i] = newObj;
					Object.assign(state.stateObject, o); //这样就有了getter,setter属性
				}
			}
		},
		stateFn2(state, source) {
			Object.assign(state.stateObject, source);
		}
	}
})

function _type(obj, name) {
	return Object.prototype.toString.call(obj) === "[object " + name + "]";
}

function isPlainObject(obj) {
	return !!obj && _type(obj, 'Object') && _type(obj.isPrototypeOf, 'Function');
}

function deepClone() {
	var target = arguments[0] || {},
		i = 1,
		length = arguments.length,
		deep = false,
		options, name, src, copy;
	if (typeof target === "boolean") {
		deep = target;
		target = arguments[1] || {};
		i = 2;
	}
	if (typeof target !== "object" && !_type(target, 'Function')) {
		target = {};
	}
	if (length === i) {
		target = this;
		--i;
	}
	for (; i < length; i++) {
		if ((options = arguments[i]) != null) {
			for (name in options) {
				src = target[name];
				copy = options[name];
				if (target === copy) {
					continue;
				}
				if (deep && copy && (isPlainObject(copy) || _type(copy, 'Array'))) {
					var clone = (src && (isPlainObject(src) || _type(src, 'Array'))) ? src : (_type(copy, 'Array') ? [] : {});
					target[name] = deepClone(deep, clone, copy);
				} else if (copy !== undefined) {
					target[name] = copy;
				}
			}
		}
	}
	return target;
}

export default store


// WEBPACK FOOTER //
// ./src/vuex/store.js